import React, { type ComponentProps, type PropsWithChildren } from 'react';
import { type Href, Link } from 'expo-router';
import { StyleSheet, TouchableOpacity } from 'react-native';

// ─────────────────────────────────────────────────────────────────────────────

export const HomeProductCardPressable = (props: Props) => {
  const { children, deepLink, onPress, style } = props;

  // ─── Styles ────────────────────────────────────────────────────────────────

  const linkStyle = StyleSheet.flatten(style);

  if (deepLink) {
    return (
      <Link asChild href={deepLink as Href}>
        <TouchableOpacity style={linkStyle} onPress={onPress}>
          {children}
        </TouchableOpacity>
      </Link>
    );
  }

  return (
    <TouchableOpacity accessibilityRole="button" style={style} onPress={onPress}>
      {children}
    </TouchableOpacity>
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  deepLink?: string;
  onPress: NonNullable<ComponentProps<typeof TouchableOpacity>['onPress']>;
  style: ComponentProps<typeof TouchableOpacity>['style'];
}>;
